import { useCallback, useEffect } from 'react'

export const useFormConfig = () => {
	const adjustFontSize = useCallback(() => {
		const spans = document.querySelectorAll(
			'#main-form .label-floating .control-label span:not(.required)'
		)
		spans.forEach((span) => {
			if (span instanceof HTMLSpanElement) {
				span.style.fontSize = '' // reset the fontSize to its default

				const grandparent = span.parentElement?.parentElement
				let fontSize = parseFloat(
					window.getComputedStyle(span).fontSize
				)
				if (grandparent) {
					while (
						span.getBoundingClientRect().width + 30 >
							grandparent.getBoundingClientRect().width &&
						fontSize > 10
					) {
						span.style.fontSize = --fontSize + 'px'
						span.getBoundingClientRect()
					}
				}
			}
		})
	}, [])

	useEffect(() => {
		const observer = new MutationObserver(() => adjustFontSize())
		observer.observe(document.body, { childList: true, subtree: true })

		requestAnimationFrame(adjustFontSize) // Run once when loaded

		window.addEventListener('resize', adjustFontSize)

		return () => {
			observer.disconnect()
			window.removeEventListener('resize', adjustFontSize)
		}
	}, [adjustFontSize])
}
